<template>
  <div>
    <div class="d-flex align-items-center">
    <h4>Dependents</h4>
      <button v-if="isEnrollPrimeGroup && tier != tierList.io && tier != tierList.is" @click="openDependentModal()" class="addBtn ms-2" style="margin-left: 10px; margin-top: 10px;">
        <i class="fas fa-plus plus-icon"></i>
      </button>
    </div>
    <div class="light-bg no-padding" style="overflow-x: auto;">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Relation</th>
            <th>DOB</th>
            <td>Email</td>
            <td>Phone</td>
            <td>Effective Date</td>
            <th v-if="!isEnrollPrimeGroup">SSN</th>
            <th>Gender</th>
            <th v-if="isEnrollPrimeGroup">Action</th>
          </tr>
        </thead>
        <tbody>
          <template  v-if="dependents.length > 0">
          <tr
            v-for="(dependent, index) in dependents"
            :key="dependent.dependent_id"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ dependentFullName(dependent) }}</td>
            <td>{{ dependent.relationship }}</td>
            <td>
              {{ dependent.birth_date ? dependent.birth_date : '--' }}
            </td>
            <td>{{ dependent.dep_email ?? '--' }}</td>
            <td>{{ dependent.dep_phone ?? '--' }}</td>
            <td>{{ dependent.d_effective_date ?? '--' }}</td>
            <td v-if="!isEnrollPrimeGroup">{{ dependent.ssn }}</td>
            <td>{{ dependent.gender }}</td>
            <td v-if="isEnrollPrimeGroup">
              <div class="d-flex gap-2 align-items-center">
                <button v-if="isEnrollPrimeGroup" @click="openDependentModal(dependent)" class="addBtn ms-2" style="margin-left: 10px; margin-top: 10px;">
                    <i class="fas fa-pencil-alt"></i>
                </button>
              </div>

            </td>
          </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="9" class="text-center">No dependents found</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <dependent-modal :selected-dependent="selectedDependent??{}" :dependent-requirement="dependentRequirement" :tier="tier" :groupInformation="groupInformation" @reloadInfo="$emit('reloadInfo')"
    :dependentList="dependents" @onClosedModal="clearSelectedDependent()" />
  </div>
</template>

<script>
import isEnrollPrimeGroupUtil from '../../utils/isEnrollPrimeGroupUtil';
import DependentModal from './modal/DependentModal.vue';
import { tierList } from '../../utils/constant';
export default {
  props: {
    dependents: {
      required: true,
    },
    tier:{
      required:true,
    },
    groupInformation: {
      required: true,
    },
    dependentRequirement: {
      required: true,
    },
  },
  components:{
    DependentModal,
  },
  data(){
    return {
      selectedDependent:{},
      tierList,
      row:{},
    }
  },
  methods: {
    dependentFullName(dependent) {
      return `${dependent.first_name} ${
        dependent.middle_name ? dependent.middle_name : ''
      } ${dependent.last_name}`
    },
    openDependentModal(dependent = {}){
      this.selectedDependent = dependent;
      this.$bvModal.show("depModal")
    },
    clearSelectedDependent(){
      this.selectedDependent ={};
    },
    openModal(dependent, modalId){
      this.row = dependent;
      this.$bvModal.show(modalId);
    }
  },
  computed:{
    isEnrollPrimeGroup() {
      return isEnrollPrimeGroupUtil.isEnrollPrimeGroup();
    }
  }
}
</script>
<style scoped>
.addBtn{
  background: #03c3ec;
  border: 0;
  outline: none;
  color: #fff;
  border-radius: 40px;
  display: flex;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
}
.plus-icon {
  position: relative;
  font-size: 16px;
}

.plus-icon::after {
  content: '';
  position: absolute;
  top: 18px;
  left: 18px;
  width: 18px;
  height: 18px;
  background-color: white;
  border-radius: 50%;
}
</style>
